import React from 'react';
import PropTypes from 'prop-types';
import RowsPerPageSelect from './RowsPerPageSelect';
import { PAGE_SIZE_OPTIONS } from '../../hooks/usePageSize';

// Prev / Next pager with a rows-per-page picker, for the record lists
// (proposals, invoices, purchase orders). Styled by RecordPages.css.
export default function RecordPagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  options = PAGE_SIZE_OPTIONS,
}) {
  // Shown whenever the list outgrows the smallest page, not just when it spans
  // pages, so a larger page size can always be switched back.
  if (total <= options[0]) return null;

  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className="record-pagination with-page-size">
      <div className="record-pagination-pages">
        <button className="page-btn" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          ← Prev
        </button>
        <span className="page-info">
          {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total}
        </span>
        <button
          className="page-btn"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          Next →
        </button>
      </div>
      <RowsPerPageSelect
        value={pageSize}
        options={options}
        onChange={(size) => {
          onPageSizeChange(size);
          onPageChange(1);
        }}
      />
    </div>
  );
}

RecordPagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.number),
};
